// extracted by mini-css-extract-plugin
module.exports = {"button":"Collapse_button__2f77d","right":"Collapse_right__1XDGM"};